import { useState } from "react";
import { toast } from "react-toastify";
import Tick from "@assets/images/TickGreen.png";
import Navbar from "@components/ui/Navbar";
import ButtonLoader from "@components/ui/Loaders/ButtonLoader";
import { ReactComponent as Ai } from "@assets/images/AI.svg";
import stepsBack from "@assets/images/stepsBack.jpg";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useUserData } from "@context/OAuth/AuthContext";
import { useDispatch } from "react-redux";
import { setGooglePopup } from "@redux/slices/googlePopupSlice";
import { createDietPlan, createExercisePlan } from "api/createPlans";
import { createMotivationalPlan } from "@api/motivationalCoach";

const CreatePlansModal = () => {
  const [loading, setLoading] = useState(false);
  const { setShowCreatePlan, showCreatePlan } = useUserData();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [isClosing, setIsClosing] = useState(false);

  // Add delay when closing to prevent glitch
  const handleClose = () => {
    setIsClosing(true);

    // Small delay to allow animation/transition
    setTimeout(() => {
      setShowCreatePlan(false);
      navigate("/", { replace: true });
      dispatch(setGooglePopup(true));

      setIsClosing(false);
    }, 100); // 100ms delay
  };

  const createPlan = async () => {
    setLoading(true);
    try {
      await createDietPlan();
      await createExercisePlan();
      await createMotivationalPlan();
      toast.info(t("toast.handTight"));
      handleClose(); // Use the delayed close function
    } catch (error) {
      console.log("Error submitting details", error);
      toast.error(t("toast.failedStartPlan"));
      setLoading(false);
    }
  };

  // If not showing create plan, don't render anything
  if (!showCreatePlan || isClosing) {
    return null;
  }

  return (
    <div
      className={`fixed inset-0 z-50 ${
        isClosing ? "opacity-0" : "opacity-100"
      } transition-opacity duration-100`}
    >
      <Navbar medicalModal={true} />
      <div
        className="w-full h-[calc(100%-74px)] bg-cover bg-center flex justify-center overflow-y-auto"
        style={{ backgroundImage: `url(${stepsBack})` }}
      >
        <div className="text-center bg-white rounded-lg w-full max-w-[90%] md:max-w-[632px] px-9 py-[60px] h-[fit-content] my-[30px] sm:mt-[50px] lg:mt-[80px]">
          <div className="flex justify-center">
            <img
              src={Tick}
              alt="image"
              className="w-[164px] h-[164px] md:w-[264px] md:h-[264px] mb-5"
            />
          </div>
          <h1 className="text-[24px] font-[600] font-[Lato] text-center mb-2">
            {t("createModal.createHeading")}
          </h1>
          <p className="text-[16px] text-[#535862] text-center mb-8">
            {t("createModal.gotEverything")}
            <br />
            {t("createModal.letGo")}
          </p>
          <button
            onClick={createPlan}
            className={`px-[20px] py-[10px] text-center bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] text-white rounded-[100px] text-[16px] min-w-[200px] min-h-[44px] font-[600] font-[Lato] ${
              loading ? "opacity-70" : ""
            }`}
            disabled={loading}
          >
            {loading ? (
              <ButtonLoader />
            ) : (
              <div className="flex items-center justify-center gap-2">
                {t("createModal.createMyPlansBtn")} <Ai />
              </div>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default CreatePlansModal;
